import { useState, useEffect, useCallback } from 'react';

declare global {
  interface Window {
    liff: any;
  }
}

export const LIFF_ID = import.meta.env.VITE_LIFF_ID || '';

export const initLIFF = async () => {
  try {
    if (typeof window === 'undefined') return { isInLIFF: false, profile: null };
    if (!window.liff || !LIFF_ID) return { isInLIFF: false, profile: null };
    
    await window.liff.init({ liffId: LIFF_ID });
    
    const isInLIFF = window.liff.isInLIFFClient;
    let profile = null;
    
    if (isInLIFF && window.liff.getProfile) {
      try {
        profile = await window.liff.getProfile();
      } catch {
        // ไม่มีสิทธิ์เข้าถึง profile
      }
    }
    
    return { isInLIFF, profile };
  } catch (error) {
    console.error('LIFF init error:', error);
    return { isInLIFF: false, profile: null };
  }
};

export const closeLIFF = () => {
  if (window.liff && window.liff.close) {
    window.liff.close();
  }
};

export const openLIFFWindow = (url: string) => {
  if (window.liff && window.liff.openWindow) {
    window.liff.openWindow({ url });
  }
};

export const shareLIFFTarget = () => {
  if (window.liff && window.liff.shareTarget) {
    window.liff.shareTarget({
      type: 'none',
      text: '🏠 นราวดี อิลิแกนซ์ - ระบบจัดการหมู่บ้านจัดสรร\nเปิดใช้งานได้ที่ลิงก์นี้',
    });
  }
};

export const isLoggedIn = () => {
  if (window.liff) {
    return window.liff.isLoggedIn();
  }
  return false;
};

export const loginWithLIFF = async () => {
  if (window.liff && !window.liff.isLoggedIn()) {
    await window.liff.login();
  }
};

export const logoutFromLIFF = () => {
  if (window.liff && window.liff.isLoggedIn()) {
    window.liff.logout();
  }
};
